<template>
  <div class="app_main">
    <div class="banner">
      <picture>
        <source
          media="(max-width: 768px)"
          srcset="@/assets/images/products/concept/banner_m.png"
        />
        <img src="@/assets/images/products/concept/banner.png" alt="豫知科技" />
      </picture>
      <!-- <div class="p_banner_des">
        <p>产品与方案</p>
        <p class="p_banner_des_sub">
          致力于提升我国医源性感染科室的感染风控能力
        </p>
      </div> -->
    </div>
    <div class="xgn margin_t">
      <div class="title"></div>
      <div class="base_layout">
        <div class="xgn_content">
          <p
            class="wow animate__animated animate__fadeIn"
            data-wow-delay="0.8s"
            data-wow-duration="1.2s"
          >
            新概念套箱式洁净手术室提供低噪声、无污<br />染的静音环境，确保病人在最安全的条件下<br />进行手术。
          </p>
        </div>
      </div>
    </div>
    <div class="xgn_solution margin_t">
      <div class="title"></div>
      <div class="base_layout">
        <div class="title_h4">方案优势</div>
        <div class="xgn_solution_1">
          <div class="box box1">取消设备层，节约空间</div>
          <div class="box box2">
            <div class="box_c">
              <p>节省建设成本，运营成本节省80%</p>
              <p class="tex_small">(选配光伏系统耗电成本直降为0)</p>
            </div>
          </div>
          <div class="box box3">常规维护成本低廉</div>
        </div>
      </div>
    </div>
    <div class="xgn_solution xq">
      <div class="base_layout">
        <div class="title_h4">方案详情</div>
      </div>
      <div class="solution_xq">
        <div class="base_layout">
          <div class="box">
            <p class="num">01</p>
            <p class="xq_h">执行标准</p>
            <p class="xq_c t_left">
              《医院洁净手术部建筑技术规范》GB50333-2013
            </p>
          </div>
          <div class="box">
            <p class="num">02</p>
            <p class="xq_h">标准执行情况</p>
            <p class="xq_c">各项参数高于国家验收指标</p>
          </div>
          <div class="box">
            <p class="num">03</p>
            <p class="xq_h">专业装饰装修造价</p>
            <p class="xq_c t_left">经典洁净手术室与套箱式洁净手术室造价相同</p>
          </div>
        </div>
      </div>
    </div>
    <div class="xgn_solution xq">
      <div class="base_layout">
        <div class="title_h4">手术室建设</div>
      </div>
      <div class="solution_js">
        <div class="base_layout">
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_1.png"
                alt="手术室墙"
              />
            </p>
            <p class="js_title">手术室墙</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_2.png"
                alt="手术室气密门"
              />
            </p>
            <p class="js_title">手术室气密门</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_3.png"
                alt="吊顶"
              />
            </p>
            <p class="js_title">吊顶</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_4.png"
                alt="回风通道"
              />
            </p>
            <p class="js_title">回风通道</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_5.png"
                alt="控制板"
              />
            </p>
            <p class="js_title">控制板</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_6.png"
                alt="灯具"
              />
            </p>
            <p class="js_title">灯具</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_7.png"
                alt="一体式净化机组"
              />
            </p>
            <p class="js_title">一体式净化机组</p>
          </div>
          <div class="js_box">
            <p class="js_icon">
              <img
                src="@/assets/images/products/concept/js_icon_8.png"
                alt="智能多联空调"
              />
            </p>
            <p class="js_title">智能多联空调</p>
          </div>
        </div>
      </div>
    </div>
    <div class="xgn_solution xq">
      <div class="base_layout">
        <div class="title_h4">工艺对比</div>
        <div
          class="category wow animate__animated animate__zoomIn"
          data-wow-delay="0.5s"
          data-wow-duration="1.2s"
        >
          <p class="item">老工艺</p>
          <p class="item">新工艺</p>
        </div>
        <div class="solution_xl">
          <div class="solution_xl_l">
            <div class="solution_xl_t">老工艺</div>
            <div class="item">
              <div class="item_name">造价成本</div>
              <div class="item_l">100mm设备层，造价100～500万</div>
            </div>
            <div class="item">
              <div class="item_name">污染状况</div>
              <div class="item_l">水平、垂直夹层整体相通，存在较严重污染</div>
            </div>
            <div class="item">
              <div class="item_name">一体式净化机组</div>
              <div class="item_l">高噪声，必须远离手术室，在设备层安装</div>
            </div>
            <div class="item">
              <div class="item_name">空调系统</div>
              <div class="item_l">独立的制冷空调 + 大功率制热电加热器</div>
            </div>
            <div class="item">
              <div class="item_name">安装工艺</div>
              <div class="item_l">
                净化机组与手术室分离安装，大量的送回风管、风阀、消音器，填满设备层与夹层空间
              </div>
            </div>
            <div class="item">
              <div class="item_name">能源消耗</div>
              <div class="item_l">
                <div>
                  <p>百万级洁净手术室</p>
                  <p class="small">使用能耗：50.6KW(总功率)</p>
                  <p class="small">停用能耗：不能做到0能耗</p>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="item_name">后期维护</div>
              <div class="item_l">可改装性、维修性、安全性都相对较差</div>
            </div>
            <div class="xl_vs"></div>
          </div>
          <div
            class="solution_xl_x wow animate__animated animate__zoomIn"
            data-wow-delay="0.8s"
            data-wow-duration="1.2s"
          >
            <div class="solution_xl_t">新工艺</div>
            <div class="item">
              <div class="item_name">造价成本</div>
              <div class="item_l">100mm设备层，造价100～500万</div>
              <div class="item_r">
                无需设备层，单间造价即可节省上百万 (地区不同设备层造价 100—500
                万不等）
              </div>
            </div>
            <div class="item">
              <div class="item_name">污染状况</div>
              <div class="item_l">水平、垂直夹层整体相通，存在较严重污染</div>
              <div class="item_r">手术室气密封闭，无污染</div>
            </div>
            <div class="item">
              <div class="item_name">一体式净化机组</div>
              <div class="item_l">高噪声，必须远离手术室，在设备层安装</div>
              <div class="item_r">
                自主创新设计超低噪声，在手术室送风天花上方与顶板间垂直安装
              </div>
            </div>
            <div class="item">
              <div class="item_name">空调系统</div>
              <div class="item_l">独立的制冷空调 + 大功率制热电加热器</div>
              <div class="item_r">制冷、制热全直流变频智能多联空调系统</div>
            </div>
            <div class="item">
              <div class="item_name">安装工艺</div>
              <div class="item_l">
                净化机组与手术室分离安装，大量的送回风管、风阀、消音器，填满设备层与夹层空间
              </div>
              <div class="item_r">
                <p>套箱式洁净手术室无风管、无风阀、无单体消音器</p>
                <p class="small">
                  (1)自主设计、悬浮安装的一体式净化机组，整体上就是一
                  个全频段隔振、吸声体；
                </p>
                <p class="small">(2)风量、风压、风速调节均为超低噪音风机；</p>
                <p class="small">(3)套箱垂直与水平夹层为等效回风管道。</p>
              </div>
            </div>
            <div class="item">
              <div class="item_name">能源消耗</div>
              <div class="item_l">
                <div>
                  <p>百万级洁净手术室</p>
                  <p class="small">使用能耗：50.6KW(总功率)</p>
                  <p class="small">停用能耗：不能做到0能耗</p>
                </div>
              </div>
              <div class="item_r">
                <p>百万级洁净手术室</p>
                <p class="small">
                  使用能耗：8.36KW（与经典洁净手术室节能高达85%）
                </p>
                <p class="small">停用能耗：0能耗</p>
              </div>
            </div>
            <div class="item">
              <div class="item_name">后期维护</div>
              <div class="item_l">可改装性、维修性、安全性都相对较差</div>
              <div class="item_r">
                设备全部完成安装后，预留较大空间，为后期改装提供可能，且所有部件独立安装，便于后期维修与巡视
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/utils/wow.js";
export default {
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
};
</script>
